import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0L24 0 24 24 0 24z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M20 11L7.83 11 13.42 5.41 12 4 4 12 12 20 13.41 18.59 7.83 13 20 13z"
})), 'ArrowBack');